import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import CopyrightIcon from "@material-ui/icons/Copyright"
import { format } from "date-fns";

const useStyles = makeStyles(theme => ({
  appBar: {
    top: "auto",
    bottom: 0,
    zIndex: 998,
    left: 0,
    width: 300
  },
  typography: {
    width: "100%",
  },
  copyright: {
    verticalAlign: "middle",
    marginRight: theme.spacing(0.5),
  },
}))

const Footer = () => {
  const classes = useStyles()
  return (
    <AppBar position="fixed" color="primary" className={classes.appBar}>
      <Toolbar>
        <Typography
          variant="body2"
          align="center"
          className={classes.typography}
        >
          <CopyrightIcon fontSize="inherit" className={classes.copyright} />
          {new Date().getFullYear()} ACE Hardware Philippines           
          <br />
          <span style={{ fontSize: "11px" }}>Version { process.env.REACT_APP_VERSION } | { format( new Date( process.env.REACT_APP_APP_BUILD_DATE ), "MMM dd, yyyy")} </span>
          <br/>
          <span style={{ fontWeight: "bold", fontSize: "10px" }}>Powered by SMIC AppLabs</span>    
        </Typography>
      </Toolbar>
    </AppBar>
  )
}

export default Footer
